import { ButtonHTMLAttributes, FC } from 'react'

import { s } from './styles'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  value: string | number
  active?: boolean
}

export const PaginationNumber: FC<ButtonProps> = (props) => {
  const { value, active = false, ...rest } = props

  if (active) {
    return <s.ButtonActive {...rest}>{value}</s.ButtonActive>
  }

  return <s.Button {...rest}>{value}</s.Button>
}
